export const trackEvent = ({ action, category, value }) => {
  window.gtag('event', action, {
    event_category: category,
    value: value
  })
}
